import { createAsyncThunk } from '@reduxjs/toolkit';

export interface SaveDataTableColumnWidthArguments {
    projectId: number;
    dataTableId: number;
    columnId: string;
    width: number;
}

export const saveDataTableColumnWidth = createAsyncThunk(
    'dataRequest/saveDataTableColumnWidth',
    async (args: SaveDataTableColumnWidthArguments, thunkAPI: any) => {
        const axios = thunkAPI.getState().core.axios;
        await axios.put(
            `/api/dataRequestProjects/${args.projectId}/dataTables/${args.dataTableId}/DataTableColumns/width`,
            { width: Math.round(args.width), columnId: args.columnId }
        );
    }
);
